import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { contact } from '../data/portfolio';
import './Contact.css';

// Bacolod City
const POSITION = [10.6765, 122.9509];

// OpenStreetMap's standard tiles are free and need no API key. They are
// light by default; Contact.css re-colours them to match the site.
const TILE_URL = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
const TILE_ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

const markerIcon = new L.DivIcon({
  className: 'map-marker',
  html: '<span class="map-marker-ring"></span><span class="map-marker-dot"></span>',
  iconSize: [28, 28],
  iconAnchor: [14, 14],
  popupAnchor: [0, -16],
});

const formatLocalTime = () =>
  new Intl.DateTimeFormat('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Asia/Manila',
  }).format(new Date());

const useLocalTime = () => {
  const [time, setTime] = useState(formatLocalTime);
  useEffect(() => {
    const id = setInterval(() => setTime(formatLocalTime()), 30000);
    return () => clearInterval(id);
  }, []);
  return time;
};

const Contact = () => {
  const localTime = useLocalTime();

  return (
    <footer id="contact" className="contact">
      <div className="contact-inner wrap">
        <span className="contact-eyebrow mono">[05] — Next layer: yours</span>

        <a href={`mailto:${contact.email}`} className="contact-headline display">
          Let’s build{' '}<br />the whole{' '}<br />thing →
        </a>

        <div className="contact-row">
          <div className="contact-lines">
            <div className="contact-line">
              <span className="contact-label mono">Email</span>
              <a href={`mailto:${contact.email}`} className="contact-value">{contact.email}</a>
            </div>
            <div className="contact-line">
              <span className="contact-label mono">Phone</span>
              <a href={`tel:${contact.phone}`} className="contact-value">{contact.phoneLabel}</a>
            </div>
          </div>
          <nav aria-label="Elsewhere" className="contact-links mono">
            <a href={contact.github} target="_blank" rel="noopener noreferrer" className="contact-link">GitHub ↗</a>
            <a href={contact.linkedin} target="_blank" rel="noopener noreferrer" className="contact-link">LinkedIn ↗</a>
            <Link to="/projects" className="contact-link contact-link--solid">All projects →</Link>
          </nav>
        </div>

        <div className="location">
          <div className="location-info mono">
            <span className="location-label">Fig. 2 — Location</span>
            <span className="location-city">Bacolod City,{' '}<br />Philippines</span>
            <dl className="location-facts">
              <div><dt>Coordinates</dt><dd>10.68° N, 122.95° E</dd></div>
              <div><dt>Time zone</dt><dd>UTC+8</dd></div>
              <div><dt>Local time</dt><dd>{localTime}</dd></div>
              <div><dt>Works</dt><dd>Remote, worldwide</dd></div>
            </dl>
          </div>
          <div className="location-map">
            <MapContainer
              center={POSITION}
              zoom={13}
              scrollWheelZoom={false}
              className="leaflet-map"
              aria-label="Map of Bacolod City, Philippines"
            >
              <TileLayer url={TILE_URL} attribution={TILE_ATTRIBUTION} maxZoom={19} />
              <Marker position={POSITION} icon={markerIcon}>
                <Popup>
                  <strong>Bacolod City, PH</strong>
                  <br />
                  Benjo M. Abrasado
                </Popup>
              </Marker>
            </MapContainer>
          </div>
        </div>

        <div className="contact-foot mono">
          <span>© {new Date().getFullYear()} Benjo M. Abrasado</span>
          <span>Compiled in Bacolod City, Philippines</span>
          <a href="#top">Back to the top ↑</a>
        </div>
      </div>
    </footer>
  );
};

export default Contact;
